import services from 'genesis-suite/services'

import userManager from './userManager'

const baseUrls = {
    integration: window.TADA_APIS.INTEGRATION,
    orgWeb: window.TADA_APIS.ORG_WEB,
    domainregistryapi: window.TADA_APIS.DOMAIN_REGISTRY,
    sso: window.TADA_APIS.SSO,
}

const getAccessKey = () => userManager.getUser().then(user => user?.profile.TADAAccessKey as string)

const onUnauthorized = () => userManager.signoutRedirect()

const getAccessToken = () => userManager.getUser().then(user => user.access_token)

const {
    architectureService,
    applicationService,
    authService,
    databaseService,
    deploymentService,
    insightService,
    modelService,
    moduleService,
    projectService,
    sessionService,
    userService,
    workspaceService,
    filterService,
    domainService,
} = services({ baseUrls, getAccessKey, onUnauthorized, shouldUseToCamel: true, getAccessToken })

export {
    architectureService,
    applicationService,
    authService,
    databaseService,
    deploymentService,
    insightService,
    modelService,
    moduleService,
    projectService,
    sessionService,
    userService,
    workspaceService,
    filterService,
    domainService,
}
